export enum NodeType {
  Emission = 0,
  Solution = 2,
  Indicator = 3,
  Target = 5,
  SupplyTarget = 6,
}
